import React, { useRef, useEffect, useState } from 'react';

const AudioPlayer = ({ audioUrl, title }) => {
  const audioRef = useRef(null);
  const containerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  
  useEffect(() => {
    // Disable right-click on the container
    if (containerRef.current) {
      containerRef.current.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
      });
      
      // Find the audio element and disable right-click
      if (audioRef.current) {
        audioRef.current.addEventListener('contextmenu', (e) => {
          e.preventDefault();
          return false;
        });
        
        // Disable controls that might allow download
        audioRef.current.controlsList = "nodownload";
        
        // Add event listeners
        audioRef.current.addEventListener('loadedmetadata', () => {
          setDuration(audioRef.current.duration);
        });
        
        audioRef.current.addEventListener('timeupdate', () => {
          setCurrentTime(audioRef.current.currentTime);
          setProgress((audioRef.current.currentTime / audioRef.current.duration) * 100);
        });
        
        audioRef.current.addEventListener('ended', () => {
          setIsPlaying(false);
        });
      }
    }
    
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('loadedmetadata', () => {});
        audioRef.current.removeEventListener('timeupdate', () => {});
        audioRef.current.removeEventListener('ended', () => {});
      }
    };
  }, [audioUrl]);
  
  const togglePlay = () => {
    if (audioRef.current.paused) {
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };
  
  const handleProgressClick = (e) => {
    const progressBar = e.currentTarget;
    const clickPosition = (e.clientX - progressBar.getBoundingClientRect().left) / progressBar.offsetWidth;
    const newTime = clickPosition * audioRef.current.duration;
    
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
    setProgress(clickPosition * 100);
  };
  
  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };
  
  return (
    <div 
      ref={containerRef} 
      className="flex flex-col items-center justify-center py-10 px-4"
      onContextMenu={(e) => {
        e.preventDefault();
        return false;
      }}
    >
      <div className="w-full max-w-2xl mx-auto">
        <div className="rounded-lg overflow-hidden shadow-sm bg-green-50 p-6 border border-green-100">
          <audio 
            ref={audioRef}
            src={audioUrl}
            crossOrigin="anonymous"
            controlsList="nodownload"
            className="hidden"
          />
          
          {/* Custom audio player controls */}
          <div className="flex flex-col space-y-4">
            <div className="flex items-center justify-between">
              <button 
                onClick={togglePlay}
                className="w-12 h-12 bg-green-600 hover:bg-green-700 rounded-full flex items-center justify-center focus:outline-none transition-all shadow-sm hover:shadow-md"
              >
                {isPlaying ? (
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <rect x="6" y="4" width="4" height="16" fill="currentColor" />
                    <rect x="14" y="4" width="4" height="16" fill="currentColor" />
                  </svg>
                ) : (
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <polygon points="5,3 19,12 5,21" fill="currentColor" />
                  </svg>
                )}
              </button>
              
              <div className="text-sm font-medium text-gray-600 bg-white px-3 py-1 rounded-full shadow-sm border border-green-100">
                {formatTime(currentTime)} / {formatTime(duration)}
              </div>
            </div>
            
            {/* Progress bar */}
            <div 
              className="h-2 bg-white rounded-full cursor-pointer relative overflow-hidden shadow-sm"
              onClick={handleProgressClick}
            >
              <div 
                className="h-full bg-green-600 rounded-full absolute top-0 left-0 transition-all"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </div>
        <p className="text-gray-700 text-center mt-6">
          Questo contenuto è ad accesso esclusivo e protetto da copyright
        </p>
      </div>
    </div>
  );
};

export default AudioPlayer;